import { FileText, HelpCircle, LayoutPanelTop, Video } from 'lucide-react'
import PropTypes from 'prop-types'

import { Badge } from '@/components/elements/badge'
import StatusIcon from '@/components/StatusIcon/StatusIcon'
import { cn } from '@/utils/helpers'

export const TYPE_ICON = {
  PDF: FileText,
  Video,
  Articulate: LayoutPanelTop,
  'Quiz Only': HelpCircle,
}

const TYPE_LABEL = {
  PDF: 'Reading',
  Video: 'Video',
  Articulate: 'Interactive',
  'Quiz Only': 'Quiz',
}

function CourseStepList({ records }) {
  if (!records || records.length === 0) return null
  return (
    <ol className="border-border bg-card divide-border flex flex-col divide-y rounded-md border">
      {records.map((record, idx) => {
        const type = record.content?.type
        const Icon = TYPE_ICON[type] ?? FileText
        const name = record.content?.name || TYPE_LABEL[type] || 'Step'
        const status = record.status || 'Not Started'
        const hasInlineQuiz = !!record.content?.quiz && type !== 'Quiz Only'
        return (
          <li
            key={record.id}
            className={cn(
              'flex items-center gap-3 px-4 py-3 text-sm',
              status === 'Not Started' && 'text-muted-foreground',
            )}
          >
            <StatusIcon status={status === 'Quiz Pending' ? 'In Progress' : status} size="small" />
            <span className="text-muted-foreground tabular-nums">{idx + 1}.</span>
            <Icon className="text-muted-foreground h-4 w-4 shrink-0" aria-hidden="true" />
            <span className="text-foreground flex-1 truncate font-medium">{name}</span>
            {hasInlineQuiz && (
              <Badge variant="outline" size="default">
                + Quiz
              </Badge>
            )}
          </li>
        )
      })}
    </ol>
  )
}

CourseStepList.propTypes = {
  records: PropTypes.array,
}

export default CourseStepList
